
























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IOffer } from "@/types/offer";
import { IPost, IPostCreateRequest } from "@/types/post";
import PostForm from "@/components/sale/forms/PostForm.vue";
import { ISelectItem } from "@/types";
import { PostCreateRequest } from "@/models/post";
import { IOfferStatusListRequest } from "@/types/offerStatus";

@Component({
  components: {
    PostForm,
  },
})
export default class extends Vue {
  @Action("offer/salesGet")
  public get!: (id: number) => Promise<void>;

  @Getter("offer/single")
  public offer!: IOffer;

  @Action("offer/salesDelete")
  public delete!: (id: number) => Promise<boolean>;

  @Mutation("offer/clear")
  public clear!: () => void;

  @Action("post/salesOfferPostCreate")
  public create!: (data: {
    postable_id: number;
    params: IPostCreateRequest;
  }) => Promise<boolean>;

  @Getter("post/single")
  public newPost!: IPost;

  @Action("offerStatus/getList")
  public getStatuses!: (params: IOfferStatusListRequest) => Promise<void>;

  @Getter("offerStatus/selectItem")
  public offerStatuses!: ISelectItem[];

  @Action("progress/flipStatus")
  public progress!: (progress_id: number) => Promise<boolean>;

  public offer_id = 0;
  public offerStatusId = 0;
  public dialog = false;

  public params: IPostCreateRequest = new PostCreateRequest();

  public async created() {
    this.offer_id = Number(this.$route.params.offer_id);

    this.clear();
    await Promise.all([
      this.get(this.offer_id),
      this.getStatuses({ per_page: 0 }),
    ]);
    this.params.status_id = this.offer.offer_status_id;
  }

  public async destroy() {
    const result = await this.delete(this.offer_id);
    if (result) {
      this.$router.go(-1);
    }
  }

  public get posts(): IPost[] {
    return this.offer.posts;
  }

  public get editPage() {
    return {
      name: "SalesOfferEdit",
      params: { offer_id: this.offer_id },
    };
  }

  public async postCreated() {
    if (this.offer_id) {
      const result = await this.create({
        postable_id: this.offer_id,
        params: this.params,
      });
      if (result) {
        this.params.contents = "";
        await this.get(this.offer_id);
      }
    }
  }

  public async updateProgress(id: number) {
    await this.progress(id);
  }
}
